import { Box, Container, Heading, Text, VStack, Button } from "@chakra-ui/react";
import { useSearchParams, Link as RouterLink } from "react-router-dom";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  return (
    <Box bg="#F7F5EB" color="#0E2721" minH="100vh" py={20}>
      <Container maxW="2xl">
        <VStack spacing={6} textAlign="center">
          <Heading color="#1C4C3F">Thank you! 🎉</Heading>
          <Text>Payment received. Check your email for the download link.</Text>
          {sessionId && (
            <Text fontSize="sm" opacity={0.7}>
              Session ID: {sessionId}
            </Text>
          )}
          <Button as={RouterLink} to="/" bg="#1C4C3F" color="white" _hover={{ opacity: 0.9 }}>
            Go to homepage
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}
